/** priorityOrder: เลขน้อย = สำคัญกว่า (null = ไม่ระบุ / ปกติ) */

export const PRIORITY_ORDER_OPTIONS = [
  { value: 1, label: "ສູງສຸດ" },
  { value: 2, label: "ສູງ" },
  { value: 3, label: "ປານກາງ" },
  { value: 4, label: "ຕ່ຳ" },
  { value: 5, label: "ຕ່ຳສຸດ" },
] as const;

const LABEL_BY_VALUE: Record<number, string> = Object.fromEntries(
  PRIORITY_ORDER_OPTIONS.map((o) => [o.value, o.label]),
);

/** สี badge ตามระดับ — สูงสุด = แดง, ต่ำ = เทา */
const BADGE_CLASS_BY_VALUE: Record<number, string> = {
  1: "border-transparent bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400",
  2: "border-transparent bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400",
  3: "border-transparent bg-amber-100 text-amber-900 dark:bg-amber-900/30 dark:text-amber-400",
  4: "border-transparent bg-sky-100 text-sky-800 dark:bg-sky-900/30 dark:text-sky-400",
  5: "border-transparent bg-slate-100 text-slate-700 dark:bg-slate-800/50 dark:text-slate-300",
};

const BADGE_CLASS_NONE =
  "border-transparent bg-muted text-muted-foreground";

export function formatPriorityOrderLabel(
  priorityOrder: number | null | undefined,
): string {
  if (priorityOrder == null) return "ປົກກະຕິ";
  return LABEL_BY_VALUE[priorityOrder] ?? `ລຳດັບ ${priorityOrder}`;
}

export function getPriorityOrderBadgeClass(
  priorityOrder: number | null | undefined,
): string {
  if (priorityOrder == null) return BADGE_CLASS_NONE;
  return BADGE_CLASS_BY_VALUE[priorityOrder] ?? BADGE_CLASS_NONE;
}

/** Sentinel สำหรับ FormSelect — ห้ามใช้ "" (Radix Select.Item ไม่รับ empty string) */
export const PRIORITY_ORDER_NONE_VALUE = "none";

/** สำหรับ FormSelect — value เป็น string */
export const PRIORITY_ORDER_SELECT_OPTIONS = [
  { value: PRIORITY_ORDER_NONE_VALUE, label: "ປົກກະຕິ (ບໍ່ລະບຸ)" },
  ...PRIORITY_ORDER_OPTIONS.map((o) => ({
    value: String(o.value),
    label: o.label,
  })),
];
